(function () {
    const tickSlider = () => {
        $(".ticker").each(function () {
            const $this = $(this);
            const id = $this.attr("id");
            const tickerId = $this.data("ticker-id");
            const tickerSpeed = $this.data("ticker-speed") * 1000;
            // Configuración ajustada de Swiper
            const tickerSwiper = new Swiper(`#${id} .ticker-js-${tickerId}`, {
                slidesPerView: 'auto',
                speed: tickerSpeed,
                loop: true,
                allowTouchMove: false,
                spaceBetween: 24, // Gap entre slides
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                // Mejora para efecto de bucle
                loopAdditionalSlides: 30, // Aumenta el número de slides duplicados en el bucle
                loopedSlides: 30, // Asegura una cantidad adecuada de slides para el bucle
            });
        });
    };
    document.addEventListener("shopify:section:load", function () {
        setTimeout(() => {
            tickSlider();
        }, 100);
    });
    setTimeout(() => {
        tickSlider();
    }, 100);
})();
